/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { addModuloID } from '~/store/modules/Modulos/actions';
import Lista from './Lista';
import { Container } from './styles';

function Card({ modulos, loading, selected, setSelected, setLoading }) {
  const dispatch = useDispatch();
  return (
    <Container>
      <Form style={{ width: '100%' }} onSubmit={() => setSelected(true)}>
        <FormGroup>
          <Label>Selecione o módulo</Label>
          <Input
            placeholder="Selecione..."
            type="select"
            // eslint-disable-next-line radix
            onChange={(e) => {
              dispatch(addModuloID(e.target.value));
              setSelected(false);
            }}
            defaultValue=""
            disabled={loading}
          >
            <option value="" disabled>
              Selecione...
            </option>
            {modulos.map((modulo, index) => (
              <option key={index} value={modulo.id}>
                {modulo.nome}
              </option>
            ))}
          </Input>
        </FormGroup>
        {loading ? (
          <Button color="primary" disabled>
            <Spinner size="sm" color="light" />
          </Button>
        ) : (
          <Button color="primary" onClick={() => setSelected(true)}>
            <FaSearch /> Buscar
          </Button>
        )}
      </Form>
      {selected ? <Lista loading={loading} setLoading={setLoading} /> : ''}
    </Container>
  );
}

export default Card;
